import { Controller, FieldValues, useController } from 'react-hook-form';

import { Label } from '@/components/UI/Label/Label';
import { RadioGroup } from '@/components/UI/RadioGroup/RadioGroup';

import { FieldError } from '../FieldError';
import { FieldProps } from '../types';

type RadioFieldProps<T extends FieldValues> = FieldProps<T> &
  Omit<React.ComponentPropsWithoutRef<typeof RadioGroup>, keyof FieldProps<T>>;

export const RadioField = <T extends FieldValues>({
  control,
  name,
  label,
  required,
  rules,
  defaultValue,
  ...rest
}: RadioFieldProps<T>) => {
  const { fieldState } = useController<T>({
    name,
    control,
    rules: { required: required ? 'dit veld is verplicht' : undefined, ...rules },
    defaultValue,
  });

  return (
    <div>
      {label && <Label>{label}</Label>}
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <Controller
          control={control}
          name={name}
          defaultValue={defaultValue}
          render={({ field }) => <RadioGroup defaultValue={defaultValue} {...field} {...rest} />}
        />
        <FieldError width='auto' error={fieldState.error} />
      </div>
    </div>
  );
};
